import axios from 'axios';

import { baseURL } from '../../../base-url.js';

const getAuthHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('jwt')}`
});

export default {
  namespaced: true,
  actions: {
    async cleanupData(_, { tenantId, startDate, endDate }) {
      try {
        return await axios.delete(`${baseURL}/tenant/cleanupData`, {
          params: { tenantId, startDate, endDate },
          headers: getAuthHeaders()
        });
      } catch (error) {
        throw error.response || error;
      }
    }
  }
};
